import React from "react";
import { CheckCircleIcon } from "lucide-react";
import { BuyButton, scrollToBuy } from "./BuyButton";
import { PRODUCT_IMAGE } from "../lib/data";
export function Hero() {
  const badges = ["📄 100% PDF", "⚡️ Entrega Inmediata", "📚 8 Módulos + 6 Bonos"];
  return <section className="px-4 pt-8 pb-6" data-id="element-104" data-mp="4lqiqv27hb2z">
      <h1 className="text-center text-3xl font-black leading-tight text-white drop-shadow-md sm:text-4xl" data-id="element-105" data-mp="4mrsmw7hjrj4">
        Resolvé todo tu año de{" "}
        <span className="text-[#8bc34a]" data-id="element-106" data-mp="127ec173d7daa">clases de fútbol</span> en 1 semana
      </h1>

      <button type="button" onClick={scrollToBuy} aria-label="Ver la oferta de compra" className="mt-6 block w-full overflow-hidden rounded-2xl border-2 border-[#8bc34a]/40 shadow-xl shadow-black/40" data-id="element-107" data-mp="xb5qnbykqnuo">
        <img src={PRODUCT_IMAGE} alt="Fútbol Profe Resuelto — el sistema completo para formar jugadores y dirigir equipos en cada etapa" className="w-full" data-id="element-108" data-mp="3d1a4za4glt8j" />
      </button>

      <p className="mt-6 text-center text-base font-medium leading-relaxed text-slate-100" data-id="element-109" data-mp="3j896f9neq5ny">
        Todo lo que necesitás para preparar infantiles, cadetes y juveniles —
        sin tener que aprenderlo a los golpes.
      </p>

      <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-110" data-mp="399tej4gk2sde">
        {badges.map(b => <span key={b} className="inline-flex items-center gap-1 rounded-full bg-white/95 px-3 py-1.5 text-sm font-bold text-[#0f2c4a] shadow-sm" data-id="element-111" data-mp="3e7l5nw9dmagj">
            {b}
          </span>)}
      </div>

      <div className="mt-6" data-id="element-112" data-mp="2qk3lalsfyenl">
        <BuyButton data-id="element-113" data-mp="2qkwjuzh8xxun" />
        <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-xs font-medium text-slate-200" data-id="element-114" data-mp="2qleoaje2bidn">
          <CheckCircleIcon className="h-4 w-4 text-[#8bc34a]" data-id="element-115" data-mp="2vgu0z80c388h" />
          Acceso inmediato · Pago seguro
        </p>
      </div>
    </section>;
}